import { Link } from 'ui/links';

type Props = {
  userId?: number | string;
  fullName: string;
  email: string;
};

/**
 * Displays member's name, lastname, and email
 */
export default ({ userId, fullName, email }: Props) => (
  <div>
    {userId ? (
      <Link inTable useReactRouter data-test="memberLink" href={`/members/${userId}`}>
        {fullName}
      </Link>
    ) : (
      <div>{fullName}</div>
    )}
    <div data-test="memberEmail">{email}</div>
  </div>
);
